import React from "react";
import styled, { withTheme } from "styled-components";
import PropTypes from "prop-types";

const CheckboxContainer = styled.div`
  display: inline-block;
  vertical-align: middle;
`;

const StyledCheckbox = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  width: 24px;
  height: 24px;
  background: ${(props) =>
    props?.checked ? props?.theme?.darkPurple : props?.theme?.dimGray};
  border-radius: ${(props) =>
    props?.square ? "0px" : props?.round ? "50px" : "3px"};
  transition: all 250ms;
  &:hover {
    cursor: pointer;
  }
  i {
    color: white;
    visibility: ${(props) =>
      props.checked && props.icon ? "visible" : "hidden"};
  }
  .fa-check {
    text-shadow: rgba(0, 0, 0, 0.25) 0px 10px 40px;
  }
`;

const Checkbox = (props) => {
  const { className, checked, round, icon, square, onClick, tabIndex } = props;

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      onClick();
    }
  };

  return (
    <CheckboxContainer
      data-testid={props["data-testid"] || "checkbox"}
      className={className}
      onClick={onClick}
      tabIndex={tabIndex}
      onKeyPress={handleKeyPress}
    >
      <StyledCheckbox
        checked={checked}
        round={round}
        icon={icon}
        square={square}
      >
        <i className="fas fa-check" />
      </StyledCheckbox>
    </CheckboxContainer>
  );
};

Checkbox.defaultProps = {
  className: null,
  round: false,
  icon: false,
  square: false,
  onClick: null,
  tabIndex: null,
};

Checkbox.propTypes = {
  className: PropTypes.string,
  checked: PropTypes.bool.isRequired,
  round: PropTypes.bool,
  icon: PropTypes.bool,
  square: PropTypes.bool,
  onClick: PropTypes.func,
  tabIndex: PropTypes.number,
};

export default withTheme(Checkbox);
